import MessageMixin from '@/mixins/message-mixin';
import { Component } from 'vue-property-decorator';

@Component
export default class OnMountIsLoadedMixin extends MessageMixin {
    public mounted(): void {
        this.registerIsLoaded();
    }
}
